import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useI18n } from "@/i18n";
import Navbar from "@/components/Navbar";
import { NotebookPen } from "lucide-react";

export default function Notes() {
  const { t, lang } = useI18n();
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get(`/notes?lang=${lang}`).then((r) => { setItems(r.data); setLoaded(true); }).catch(() => setLoaded(true));
  }, [lang]);

  return (
    <div className="min-h-screen bg-void">
      <Navbar />
      <main className="pt-28 pb-16 max-w-3xl mx-auto px-6" data-testid="notes-page">
        <h1 className="font-serif text-5xl text-ink mb-10 flex items-center gap-3">
          <NotebookPen className="text-gold" strokeWidth={1.5} /> {t("notes.title")}
        </h1>
        {loaded && items.length === 0 ? (
          <p className="text-ink-muted" data-testid="notes-none">{t("notes.none")}</p>
        ) : (
          <div className="space-y-4">
            {items.map((n) => (
              <Link key={n.lesson_id} to={`/lesson/${n.lesson_id}`}
                className="group block bg-graphite border border-ink/5 hover:border-gold/30 p-6 transition-colors"
                data-testid={`note-${n.lesson_id}`}>
                <div className="flex items-baseline justify-between mb-2">
                  <span className="text-lg text-ink group-hover:text-gold transition-colors">{n.title}</span>
                  <span className="text-xs text-ink-muted">{n.module_title}</span>
                </div>
                <p className="text-ink-soft text-sm leading-relaxed line-clamp-3 whitespace-pre-line">{n.text}</p>
              </Link>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
